export const RESET_BY_EMAIL = 'resetByEmail';
export const RESET_BY_TEXT = 'resetByText';
export const RESET_BY_SECURITY_QUESTIONS = 'resetBySecurityQuestions';
